module.exports = __webpack_public_path__ + "img/messi700.05a4f679.jpg";